/**
 * 資格区分
 */
export const CertificationKind = {
  BASE: 'BASE',
  SPECIALTY: 'SPECIALTY',
  HANDLING: 'HANDLING'
} as const;
export type CertificationKind = (typeof CertificationKind)[keyof typeof CertificationKind];

/**
 * 資格種別
 */
export const CertificationType = {
  NATIONAL: 'NATIONAL',
  PUBLIC: 'PUBLIC',
  PRIVATE: 'PRIVATE'
} as const;
export type CertificationType = (typeof CertificationType)[keyof typeof CertificationType];

/**
 * 業種カテゴリ
 */
export const IndustryCategory = {
  HEALTHCARE: 'HEALTHCARE',
  INSURANCE: 'INSURANCE',
  FINANCE: 'FINANCE'
} as const;
export type IndustryCategory = (typeof IndustryCategory)[keyof typeof IndustryCategory];

/**
 * コンプライアンス重要度区分
 */
export const ComplianceRiskLevel = {
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
  HIGH: 'HIGH'
} as const;
export type ComplianceRiskLevel = (typeof ComplianceRiskLevel)[keyof typeof ComplianceRiskLevel];

/**
 * 更新単位
 */
export const RenewalUnit = {
  YEAR: 'YEAR',
  MONTH: 'MONTH'
} as const;
export type RenewalUnit = (typeof RenewalUnit)[keyof typeof RenewalUnit];

/**
 * 更新期限カウント方法
 */
export const RenewalDeadlineType = {
  EXPIRATION_DATE: 'EXPIRATION_DATE',
  YEAR_END: 'YEAR_END'
} as const;
export type RenewalDeadlineType = (typeof RenewalDeadlineType)[keyof typeof RenewalDeadlineType];

/**
 * Certification Status
 */
export const CertificationStatus = {
  // 有効前
  NOT_EFFECTIVE_YET: 'NOT_EFFECTIVE_YET',
  // 有効
  EFFECTIVE: 'EFFECTIVE',
  // 廃止済み
  ARCHIVED: 'ARCHIVED'
} as const;
export type CertificationStatus = (typeof CertificationStatus)[keyof typeof CertificationStatus];

/**
 * Form ItemsのAttributeKey
 */
export const CertificationFormItemsAttributeKey = {
  AcquisitionType: 'acquisitionType',
  CertificationStatus: 'certificationStatus',
  ManagementType: 'managementType'
} as const;